import React, { useContext, useEffect, useRef } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const Carousel = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  const videoRef = useRef(null);

  useEffect(() => {
    loadLanguageFile("Carousel", "home/home_Carousel_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Carousel || { Main: {} };
  return (
    <>
      {/* ================= Carousel Section ================= */}
      <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
        <div className="carousel-inner">
          {/* Slide 1 */}
          <div className="carousel-item active">
            <img className="w-100" src="img/carousel-1.jpg" alt="Carousel 1" />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: "1200px" }}>
                <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                  {LANGUAGE.Main.Content1}
                </h5>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn" >
                  {LANGUAGE.Main.Content2}
                </h1>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn" >
                  {LANGUAGE.Main.Content3}
                </h1>
                <a href={process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in"}
                  // target="_blank"
                  className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">
                  {LANGUAGE.Main.Content4}
                </a>
                {/* <a onClick={() => alert('Stay tuned')} target="_blank" className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">
                  {LANGUAGE.Main.Content4}
                </a> */}
                <a href="https://masquant.com/products/strategy-wizard/" className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">
                  {LANGUAGE.Main.Content5}
                </a>
              </div>
            </div>
          </div>

          {/* Slide 2 */}
          <div className="carousel-item">
            <img className="w-100" src="img/carousel-2.jpg" alt="Carousel 2" />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: "1200px" }}>
                <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                  {LANGUAGE.Main.Content6}
                </h5>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn" >
                  {LANGUAGE.Main.Content7}
                </h1>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn" >
                  {LANGUAGE.Main.Content8}
                </h1>
                <a href="/product_ai" className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">
                  {LANGUAGE.Main.Content9}
                </a>
                <a href="/product_lib" className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">
                  {LANGUAGE.Main.Content10}
                </a>
              </div>
            </div>
          </div>

          {/* Slide 3 */}
          <div className="carousel-item">
            <img className="w-100" src="img/carousel-3.jpg" alt="Carousel 3" />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: "1200px" }}>
                <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                  {LANGUAGE.Main.Content11}
                </h5>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn" >
                  {LANGUAGE.Main.Content12}
                </h1>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn" >
                  {LANGUAGE.Main.Content13}
                </h1>
                <a href="/product_lib" className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">
                  {LANGUAGE.Main.Content14}
                </a>
                <a href={LANGUAGE.Main.Content22} target="_blank" className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">
                  {LANGUAGE.Main.Content15}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Carousel Controls */}
        <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      {/* ================= Facts Section ================= */}
      <div className="container-fluid facts py-5 pt-lg-0">
        <div className="container py-5 pt-lg-0">
          <div className="row gx-0">
            {/* Box 1 */}
            <div className="col-lg-4 wow zoomIn" data-wow-delay="0.1s">
              <div className="bg-primary shadow d-flex align-items-center justify-content-center p-4" style={{ height: "150px" }}>
                <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{ width: "60px", height: "60px" }}>
                  <i className="fa fa-users text-primary"></i>
                </div>
                <div className="ps-4">
                  <h5 className="text-white mb-0">{LANGUAGE.Main.Content16}</h5>
                  <h1 className="text-white mb-0">{LANGUAGE.Main.Content17}</h1>
                </div>
              </div>
            </div>

            {/* Box 2 */}
            <div className="col-lg-4 wow zoomIn" data-wow-delay="0.3s">
              <div className="bg-light shadow d-flex align-items-center justify-content-center p-4" style={{ height: "150px" }}>
                <div className="bg-primary d-flex align-items-center justify-content-center rounded mb-2" style={{ width: "60px", height: "60px" }}>
                  <i className="fa fa-check text-white"></i>
                </div>
                <div className="ps-4">
                  <h5 className="text-primary mb-0">{LANGUAGE.Main.Content18}</h5>
                  <h1 className="mb-0">{LANGUAGE.Main.Content19}</h1>
                </div>
              </div>
            </div>

            {/* Box 3 */}
            <div className="col-lg-4 wow zoomIn" data-wow-delay="0.6s">
              <div className="bg-primary shadow d-flex align-items-center justify-content-center p-4" style={{ height: "150px" }}>
                <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{ width: "60px", height: "60px" }}>
                  <i className="fa fa-award text-primary"></i>
                </div>
                <div className="ps-4">
                  <h5 className="text-white mb-0">{LANGUAGE.Main.Content20}</h5>
                  <h1 className="text-white mb-0">{LANGUAGE.Main.Content21}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Carousel;
